var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeMute = function SvgVolumeMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1059 1418 19.077 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1059.615 1423.538a.581.581 0 0 0-.615.616v3.692a.581.581 0 0 0 .615.615h3.693l5.538 5.539v-16l-5.538 5.538ZM1075.861 1426l2.031-2.031a.61.61 0 0 0-.862-.862l-2.031 2.031-2.03-2.03a.61.61 0 0 0-.862.862l2.031 2.031-2.031 2.031a.6.6 0 0 0 0 .862.665.665 0 0 0 .431.185.559.559 0 0 0 .431-.185l2.031-2.031 2.031 2.031a.665.665 0 0 0 .431.185.559.559 0 0 0 .431-.185.6.6 0 0 0 0-.862Z"
  })));
};
export default SvgVolumeMute;